// static data for video tutorial, in the future need migrate to database
export const dataTutorials = [
  { videoId: 'UNZ7lywjC58', title: 'Bagaimana Cara Mengaktivasi Akun Nimbly Saya' },
  { videoId: 'e1aUQrL1tBY', title: 'Bagaimana Cara Mengatur Ulang Kata Sandi' }
];
